import { SvrConn } from "../utils/axios/index";

export const getPermisoAll = async () => {
    let res = {};
    try {
      res = await SvrConn.get("/api/permission/getpermissionall");
    } catch (Error) {
      res = Error;
    }
    return res;
  };
/**
 * 
 */
export const getPermisoInt = async (MenuId, ItemId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/permission/getpermissionint",{MenuId, ItemId});
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 * 
 */
export const actualizaPermiso = async(data)=>{
  let res = {};
    try {
      res = await SvrConn.post("/api/permission/setactualizapermission", data);
    } catch (Error) {
      res = Error;
    }
    return res;
}

